<template>
  <div style="overflow: auto;">
     <el-form ref="dataForm" class="main-form" :model="temp" :rules="rules" label-width="100px">

       <el-collapse class="normal-el-collapse" v-model="activeNames">
         <el-collapse-item title="管理信息" name="1">
           <el-row :gutter="24">
             <el-col :span="6">
               <el-form-item  label="建档机构" prop="orgCompleteName">
                 <el-input  v-model="temp.patientInfo.orgCompleteName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="初始团队" prop="manageTeamName">
                 <el-input  v-model="temp.patientInfo.manageTeamName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="建档医生" prop="archiveOperatorName">
                 <el-input  v-model="temp.patientInfo.archiveOperatorName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="录入医生" prop="manageStaffName">
                 <el-input  v-model="temp.patientInfo.manageStaffName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="建档日期" prop="archiveTime">
                 <el-date-picker v-model="temp.patientInfo.archiveTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" disabled></el-date-picker>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="档案编号" prop="archiveCode">
                 <el-input  v-model="temp.patientInfo.archiveCode" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="原档案号" prop="customCode">
                 <el-input  v-model="temp.patientInfo.customCode" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="建档状态" prop="archiveStatusName">
                 <el-input  v-model="temp.patientInfo.archiveStatusName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="人员状态" prop="sickStatusName">
                 <el-input  v-model="temp.patientInfo.sickStatusName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="建档方式" prop="archiveWay">
                 <el-radio-group v-model="temp.patientInfo.archiveWay" disabled>
                   <el-radio :label="0">上站</el-radio>
                   <el-radio :label="1">入户</el-radio>
                   <el-radio :label="2">门诊</el-radio>
                 </el-radio-group>
               </el-form-item>
             </el-col>
           </el-row>


           <el-row :gutter="24">
             <el-col :span="6">
               <el-form-item  label="辖区机构" prop="manageOrgUpper">
                 <el-input  v-model="temp.patientInfo.manageOrgUpper" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="辖区团队" prop="manageTeamName">
                 <el-input  v-model="temp.patientInfo.manageTeamName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="管理机构" prop="orgCompleteName">
                 <el-input  v-model="temp.patientInfo.orgCompleteName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="管理机构电话" prop="orgPhone">
                 <el-input  v-model="temp.patientInfo.orgPhone" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="管理团队" prop="manageTeam">
                 <el-input  v-model="temp.patientInfo.manageTeam" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="家庭医生" prop="manageStaffName">
                 <el-input  v-model="temp.patientInfo.manageStaffName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="核查医生" prop="checkDocName">
                 <el-input  v-model="temp.patientInfo.checkDocName" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="核查时间" prop="checkDate">
                 <el-date-picker v-model="temp.patientInfo.checkDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" disabled></el-date-picker>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="功能社区" prop="manageZoneZx">
                 <el-input  v-model="temp.patientInfo.manageZoneZx" disabled></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="健康档案管理状态">

               </el-form-item>
             </el-col>
           </el-row>
         </el-collapse-item>

         <el-collapse-item title="基本信息" name="3">
           <el-row :gutter="24">
             <el-col :span="6">
               <el-form-item  label="姓名" prop="sickName">
                 <el-input  v-model="temp.patientInfo.sickName"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="性别" prop="sickSex">
                 <el-select v-model="temp.patientInfo.sickSex" style="width: 100%">
                   <el-option v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                 </el-select>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="出生日期" prop="birthday">
                 <el-date-picker v-model="temp.patientInfo.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="身份证号" prop="identityCardNo">
                 <el-input  v-model="temp.patientInfo.identityCardNo"></el-input>
               </el-form-item>
             </el-col>
           </el-row>
           <el-row :gutter="24">
             <el-col :span="6">
               <el-form-item  label="工作单位" prop="sickWorkCompany">
                 <el-input  v-model="temp.patientInfo.sickWorkCompany"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="所在居村" prop="zoneName">
                 <el-input  v-model="temp.patientInfo.zoneName"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="民族" prop="nation">
                 <el-input  v-model="temp.patientInfo.nation"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="常住类型" prop="sickStatusName">
                 <el-input  v-model="temp.patientInfo.sickStatusName"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="户籍地址" prop="nativePlace">
                 <el-input  v-model="temp.patientInfo.nativePlace"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="本人电话" prop="sickPhone">
                 <el-input  v-model="temp.patientInfo.sickPhone"></el-input>
               </el-form-item>
             </el-col>
           </el-row>
           <el-row :gutter="24">
             <div style="margin-left: 60px;">
               紧急联系人
             </div>
             <el-col :span="6">
               <el-form-item  label="①姓名" prop="linkmanName">
                 <el-input  v-model="temp.patientInfo.linkmanName"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="与户主关系" prop="linkmanRelation">
                 <el-input  v-model="temp.patientInfo.linkmanRelation"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="联系人电话" prop="linkmanPhone">
                 <el-input  v-model="temp.patientInfo.linkmanPhone"></el-input>
               </el-form-item>
             </el-col>
           </el-row>


           <el-row :gutter="15">
             <el-col :span="6">
               <el-form-item  label="②姓名" prop="linkmanName2">
                 <el-input  v-model="temp.patientInfo.linkmanName2"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="与户主关系" prop="linkmanRelation2">
                 <el-input  v-model="temp.patientInfo.linkmanRelation2"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="联系人电话" prop="linkmanPhone2">
                 <el-input  v-model="temp.patientInfo.linkmanPhone2"></el-input>
               </el-form-item>
             </el-col>

           </el-row>


           <el-row :gutter="24">
             <el-col :span="6">
               <el-form-item  label="常住地址" prop="sickAddress">
                 <el-input  v-model="temp.patientInfo.sickAddress"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="文化程度" prop="education">
                 <el-input  v-model="temp.patientInfo.education"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="职业" prop="occupation">
                 <el-input  v-model="temp.patientInfo.occupation"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="婚姻状况" prop="marriage">
                 <el-input  v-model="temp.patientInfo.marriage"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="医疗费用支付方式" prop="medicalExpenses">
                 <el-input  v-model="temp.patientInfo.medicalExpenses"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="个人健康服务凭证" prop="healthServiceCard">
                 <el-input  v-model="temp.patientInfo.healthServiceCard"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="血型" prop="bloodType">
                 <el-input  v-model="temp.patientInfo.bloodType"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="RH" prop="rhType">
                 <el-input  v-model="temp.patientInfo.rhType"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="6">
               <el-form-item  label="预防接种史" prop="vaccinationHistory">
                 <el-input  v-model="temp.patientInfo.vaccinationHistory"></el-input>
               </el-form-item>
             </el-col>
           </el-row>
         </el-collapse-item>
       </el-collapse>



       <!-- 既往史 -->
       <!-- <xr-collapse  class="single-collapse" height="300px">
         <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
           <el-tab-pane label="既往史">
             <el-row :gutter="24">
               <el-col :span="24">
                 <el-form-item  label="过敏史" prop="pastAllergy">
                   <el-input  v-model="temp.patientInfo.pastAllergy"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="暴露史" prop="pastExposure">
                   <el-input  v-model="temp.patientInfo.pastExposure"></el-input>
                 </el-form-item>
               </el-col>


               <el-col :span="24">
                 <el-form-item  label="疾病" prop="pastDisease">
                   <el-input  v-model="temp.patientInfo.pastDisease"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="手术" prop="pastOperation">
                   <el-input  v-model="temp.patientInfo.pastOperation"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="外伤" prop="pastInjury">
                   <el-input  v-model="temp.patientInfo.pastInjury"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="输血" prop="pastTransfusion">
                   <el-input  v-model="temp.patientInfo.pastTransfusion"></el-input>
                 </el-form-item>
               </el-col>
             </el-row>
           </el-tab-pane>
         </el-tabs>
       </xr-collapse> -->

       <!-- 家族史 -->
       <!-- <xr-collapse  class="single-collapse" height="300px">
         <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
           <el-tab-pane label="家族史">
             <el-row :gutter="24">
               <el-col :span="24">
                 <el-form-item  label="父亲" prop="fatherHistory">
                   <el-input  v-model="temp.patientInfo.fatherHistory"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="母亲" prop="motherHistory">
                   <el-input  v-model="temp.patientInfo.motherHistory"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="兄弟姐妹" prop="brothersHistory">
                   <el-input  v-model="temp.patientInfo.brothersHistory"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="子女" prop="childrenHistory">
                   <el-input  v-model="temp.patientInfo.childrenHistory"></el-input>
                 </el-form-item>
               </el-col>

             </el-row>
           </el-tab-pane>
         </el-tabs>
       </xr-collapse> -->

       <!-- 其他 -->
<!--       <xr-collapse  class="single-collapse" height="200px">
         <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
           <el-tab-pane label="其他">
             <el-row :gutter="24">
               <el-col :span="24">
                 <el-form-item  label="遗传病史" prop="geneticDisease">
                   <el-input  v-model="temp.patientInfo.geneticDisease"></el-input>
                 </el-form-item>
               </el-col>
               <el-col :span="24">
                 <el-form-item  label="残疾情况" prop="disabilityWithout">
                   <el-input  v-model="temp.patientInfo.disabilityWithout"></el-input>
                 </el-form-item>
               </el-col>

             </el-row>
           </el-tab-pane>
         </el-tabs>
       </xr-collapse -->



     </el-form>
    </div>
</template>
<script>
  import {getToken} from '../../../../utils/auth';

  export default {
    name: "baseInfo",
    data() {
      return {
        activeNames: ['1', '3'],
        temp: {
          id: '',                                       //【基本信息】 主键ID
          patientInfo: {
            archiveId:'',
            sickStatus:'',
            zoneName:'',
            archiveCode:'',
            sickName:'',
            birthday:'',
            householdSickName:'',
            sickSex:'',
            sickAge:'',
            identityCardNo:'',
            orgCode:'',
            archiveStatusName:'',
            problemBloodFlag:'',
            problemBloodTime:'',
            problemGlucoseFlag:'',
            problemGlucoseTime:'',
            problemDeformedFlag:'',
            sickAllowanceFlag:'',
            sickAddress:'',
            archiveOperatorName:'',
            archiveTime:'',
            sickPhone:'',
            linkmanPhone:'',
            orgCompleteName:'',
            createTime:'',
            customCode:'',
            qualifiedFlag:'',
            medicalTime:'',
            supplementaryUpdate:'',
            remark:'',
            archiveStatus:'',
            archiveWay:'',         //建档方式
            sickStatusName:'',
            sickId:'',
            linkmanName:'',
            sealupTime:'',
            sealupOperatorName:'',
            manageOrg:'',
            manageTeam:'',
            manageOperator:'',
            manageOrgUpper:'',
            manageZoneZx:'',
            manageZoneQx:'',
            isSignpro:'',
            signStartTime:'',
            signEndTime:'',
            manageTeamName:'',
            manageStaffName:'',
            medicalExpenses:'',
            checkDate:'',
            checkDocName:'',
            migrateTime:'',
            orgPhone:'',
            sickWorkCompany:'',
            nativePlace:'',
            linkmanRelation:'',
            linkmanName2:'',
            linkmanRelation2:'',
            linkmanPhone2:'',
            education:'',
            occupation:'',
            marriage:'',
            healthServiceCard:'',
            bloodType:'',
            rhType:'',
            vaccinationHistory:'',
            pastAllergy:'',
            pastExposure:'',
            pastDisease:'',
            pastOperation:'',
            pastInjury:'',
            pastTransfusion:'',
            fatherHistory:'',
            motherHistory:'',
            brothersHistory:'',
            childrenHistory:'',
            geneticDisease:''
          },                                     //【基本信息】
          test:'',

        },
        test_list: [],
        sexList:[{value:'1', label:'男'},{value:'2', label:'女'}],
        rules: {
          entrustOrgName: [
            { message: '委托单位不能为空!', required: true, trigger: 'blur' }
          ],
        },
      }
    },
    components: {

    },
    methods: {
      //初始化
      init(id) {
        this.$nextTick(()=>{
          this.temp.patientInfo.archiveId = id
          this.getPageInfo(id)
        })
      },
      //获取页面所需数据
      getPageInfo(id){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tPhPatientInfo_findById',
            'archiveId': id
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if (response.data) {
            this.temp.patientInfo = response.data;
          }
        })
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ph/archive/home/home-info.vue